import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable, combineLatest, map, switchMap } from 'rxjs';
import { CrmInjectionToken } from '@galaxy/crm/static';
import { FeatureFlagsApiService } from '@vendasta/partner';

@Injectable()
export class FeatureFlagGuard {
  private readonly config = inject(CrmInjectionToken);
  private readonly featureFlagService = inject(FeatureFlagsApiService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    let featureFlag = route.data['featureFlag'];
    //TODO remove this once custom objects ff is expired
    if (featureFlag === 'crm_custom_objects') {
      featureFlag = this.config.customObjectFeatureFlag;
    }
    return combineLatest([this.config.namespace$, this.config.parentNamespace$]).pipe(
      switchMap(([namespace, parentNamespace]) => {
        return this.featureFlagService.batchGetStatus({
          featureIds: [featureFlag],
          partnerId: (parentNamespace as string) || (namespace as string),
        });
      }),
      map((response) => response?.hasAccess?.[0] || false),
    );
  }
}
